import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware } from 'lcc-state';
import { publish } from 'pub-sub';

import { RosterMember } from '../support/svc';
import { Biography } from './biography';
import { css } from '../css/instructor.m.css';

export interface InstructorProperties {
	instructors: RosterMember[];
	size?: string;
	showAskLink?: boolean;
}

interface OutputSize {
	[index: string]: {
		avatar: string[];
		bio: string[];
		actions: string[];
	};
}

const factory = create({
	nls: createNlsMiddleware('roster'),
	theme
}).properties<InstructorProperties>();

export const Instructor = factory(({ properties, middleware: { nls, theme } }) => {
	const { instructors, size, showAskLink } = properties();
	const {
		messages: { ask_the_instructor = '' }
	} = nls();

	const themedCss = theme.classes(css);

	const classesBySize: OutputSize = {
		large: {
			avatar: ['col-xs-3', 'col-sm-4', 'col-md-3', 'col-lg-3'],
			bio: ['col-xs-10', 'col-sm-10', 'col-md-9', 'col-lg-9'],
			actions: ['col-xs-9', 'col-sm-8', 'col-md-6', 'col-lg-4']
		},
		medium: {
			avatar: ['col-xs-3', 'col-sm-4', 'col-md-3', 'col-lg-3'],
			bio: ['col-xs-9', 'col-sm-8', 'col-md-8', 'col-lg-5'],
			actions: ['col-xs-9', 'col-sm-8', 'col-md-6', 'col-lg-4']
		}
	};

	const containerClasses = size && size in classesBySize ? classesBySize[size] : classesBySize.large;

	const instructorList = instructors.map((instructor: RosterMember) => {
		const avatar = instructor.has_avatar ? [v('img', { src: instructor.avatar })] : [];

		return v('div', { classes: ['row', themedCss.instructorContainer], xqa: 'roster-item' }, [
			v('div', { classes: containerClasses.avatar }, [v('span', { classes: themedCss.avatar }, avatar)]),
			v('div', { classes: containerClasses.bio }, [
				v('div', { classes: themedCss.details }, [
					v('h3', { innerHTML: instructor.fullname }),
					w(Biography, { biography: instructor.bio })
				])
			]),
			showAskLink
				? v('div', { classes: [themedCss.actionContainer, ...containerClasses.actions] }, [
						v('ul', { classes: [themedCss.userActions] }, [
							v('li', { classes: 'ask' }, [
								v('a', {
									classes: ['lp-link'],
									innerHTML: ask_the_instructor,
									onclick: (evt: MouseEvent) => {
										evt.preventDefault();
										publish('close-all/panes');
										publish('ati/open');
									}
								})
							])
						])
				  ])
				: null
		]);
	});

	return v('div', {}, instructorList);
});
